export default [
  'SETTLEMENT',
  'TIMER',
  'MANUAL',
  'MARKET_CONDITION',
  'END_OF_SETTLEMENT',
];

export const EOD_SETTLEMENT_TYPE = 'end_of_day';
export const INTRADAY_SETTLEMENT_TYPE = 'intraday';

export const SETTLEMENT_TYPE_OPTIONS = [
  { key: 'midDay', value: 'mid_day', text: 'Mid Day' },
  { key: 'adHoc', value: 'ad_hoc', text: 'Ad Hoc' },
  { key: 'endOfDay', value: EOD_SETTLEMENT_TYPE, text: 'End Of Day' },
  { key: 'intraday', value: INTRADAY_SETTLEMENT_TYPE, text: 'Intraday' },
  { key: 'final', value: 'final', text: 'Final' },
];
